import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { useIsAuthenticated as n } from "@maat/store-auth";
import { notificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/useNotificationsQuery.ts
var i = (i = 20) => {
	let a = n();
	return t({
		queryKey: e.list(),
		fetchPage: (e) => r.getNotifications(e, i),
		enabled: a,
		key: "data"
	});
};
//#endregion
export { i as useNotificationsQuery };
